import { Component } from "../components/index"
import gsap from "gsap"
import { qsa, qs } from "../utils/index"
import Marquee from "../components/Marquee"
import TextSplitScrollTrigger from "../components/TextSplitScrollTrigger"

export default class ContactForm extends Component {
  constructor(obj) {
    super(obj)

    this.inputFile = qs("#inputFile", this.el)

    this.label = qs(".label-upload", this.el)

    this.form = qs("form", this.el)

    this.originalDOM = qs(".label-upload", this.el).innerHTML

    this.success = qs(".success-message", this.el)
    this.error = qs(".error-message", this.el)

    this.splitText = qsa("[data-split]", this.el)
    this.textSplitter = new TextSplitScrollTrigger({
      el: this.el,
      splitText: this.splitText,
      animate: this.animate.bind(this),
    })
  }

  animate() {
    const title = qsa(".title .char-1", this.el)
    const items = qsa(".form > div", this.el)

    const lines = qsa(".title .line-0", this.el)

    lines.forEach(line => {
      line.style.overflow = "hidden"
    })

    gsap.from(title, {
      stagger: 0.05,
      autoAlpha: 0,
      y: "100%",
      scrollTrigger: {
        trigger: title,
        start: "top bottom",
      },
    })

    gsap.from(items, {
      stagger: 0.1,
      duration: 1.2,
      autoAlpha: 0,
      y: 100,
      scrollTrigger: {
        trigger: items,
        start: "top bottom",
      },
    })
  }

  on() {
    this.inputFile.addEventListener("change", this.onDropFile)
  }

  onDropFile = e => {
    const file = this.inputFile.files[0]

    if (!file) return

    if (file && file.size > 10 * 1024 * 1024) {
      // 10 MB in bytes
      // alert("File must be 10 MB or less.")
      this.label.innerHTML = "File must be 10 MB or less."
      setTimeout(() => {
        this.label.innerHTML = this.originalDOM
      }, 1500)
      this.inputFile.value = "" // Reset the input
      return
    }

    this.label.innerHTML = file.name
  }
}
